interface OfferMapSlugGroup {
  is_wine?: boolean;
  isMixed?: boolean;
  sku?: {
    wines?: Array<{ category: string }>;
  };
}

const mapSlugGroup = (offer?: OfferMapSlugGroup): string => {
  if (offer?.is_wine === false) return "";
  if (offer?.isMixed || (offer?.sku?.wines?.length ?? 0) > 1) {
    return "/mixed-case";
  }
  switch (offer?.sku?.wines?.[0]?.category) {
    case "Red":
    case "Dessert/Fortified":
      return "/red-wine";
    case "White":
      return "/white-wine";
    case "Rosé":
      return "/rose";
    case "Sparkling":
      return "/sparkling";
    default:
      return "";
  }
};

export default mapSlugGroup;
